export const getInitials = (name: string): string => {
  if (!name) return "";
  return name
    .trim()
    .split(/\s+/)
    .map((w) => w[0]?.toUpperCase())
    .join("")
    .slice(0, 2);
};

const avatarColors = [
  { text: "#F64649", bg: "rgba(246, 70, 73, 0.10)" },
  { text: "#466FF6", bg: "rgba(70, 111, 246, 0.10)" },
  { text: "#8C27E6", bg: "rgba(140, 39, 230, 0.10)" },
  { text: "#389C7B", bg: "rgba(56, 156, 123, 0.10)" },
  { text: "#299CDB", bg: "rgba(41, 156, 219, 0.10)" },
  { text: "#00A99D", bg: "rgba(0,169,157,0.10)" },
  { text: "#E91E63", bg: "rgba(233,30,99,0.10)" },
  { text: "#FFC02C", bg: "rgba(255,192,44,0.10)" },
  { text: "#FF6F3C", bg: "rgba(255,111,60,0.10)" },
  { text: "#0052CC", bg: "rgba(0,82,204,0.10)" },
];

export const getAvatarStyle = (name: string) => {
  if (!name?.length) {
    const { text, bg } =
      avatarColors[Math.floor(Math.random() * avatarColors.length)];
    return {
      backgroundColor: bg,
      color: text,
    };
  }
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const { text, bg } = avatarColors[Math.abs(hash % avatarColors.length)];
  return { backgroundColor: bg, color: text };
};
